document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("portfolio-modal");
  const modalTitle = document.getElementById("modal-title");
  const modalDescription = document.getElementById("modal-description");
  const modalDescription2 = document.getElementById("modal-description2");
  const closeModal = document.getElementById("close-modal");
  const slidesContainer = modal.querySelector(".swiper-wrapper");
  const zoomLens = document.querySelector('.zoom-lens');
  const imageContainer = document.querySelector('#modal-slider');
  
  let swiperInstance = null; // Track Swiper instance

  document.querySelectorAll(".ArticleItem__ImageWrapper").forEach((item) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();

      // Destroy existing Swiper instance if any
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }

      const blockId = this.getAttribute("data-id");
      const blockData = JSON.parse(
        document.getElementById(`data-${blockId}`).textContent
      );

      modalTitle.textContent = blockData.title;
      modalDescription.innerHTML = blockData.description;
      modalDescription2.innerHTML = blockData.description2;
      slidesContainer.innerHTML = "";
      
      // Rebuild slides
      // blockData.images.slice(1).forEach
      blockData.images.forEach(imgSrc => {
        const slide = document.createElement("div");
        slide.classList.add("swiper-slide");
        const img = document.createElement("img");
        img.src = imgSrc;
        slide.appendChild(img);
        slidesContainer.appendChild(slide); 
      });

      // Initialize new Swiper instance
      swiperInstance = new Swiper(".mySwiper", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: function () {
            // Your existing slide change logic
          },
        },
      });

      modal.classList.add("active");
    });
  });

  // Close modal and destroy Swiper
  function closeModalHandler() {
    modal.classList.remove("active");
    if (swiperInstance) {
      swiperInstance.destroy(true, true); // Destroy with cleanup
      swiperInstance = null;
    }
  }

  closeModal.addEventListener("click", closeModalHandler);
  modal.addEventListener("click", function (e) {
    if (e.target === modal) closeModalHandler();
  });
   imageContainer.addEventListener('mousemove', (e) => {
         let mainImage = document.querySelector(".swiper-slide-active img");
        let nextButton = document.querySelector('.swiper-button-next');
         let prevButton = document.querySelector('.swiper-button-prev');

      if (e.target.closest('.swiper-button-next') || e.target.closest('.swiper-button-prev') ) {
            zoomLens.style.display = 'none';
            return;
        }
       
        const { left, top, width, height } = mainImage.getBoundingClientRect();
        const lensSize = zoomLens.offsetWidth;
        const zoomFactor = 2; // How much to zoom

        let x = e.pageX - left - window.scrollX;
        let y = e.pageY - top - window.scrollY;

        // Prevent lens from going outside the image
        x = Math.max(0, Math.min(width, x));
        y = Math.max(0, Math.min(height, y));

        const lensX = x - lensSize / 2;
        const lensY = y - lensSize / 2;

        zoomLens.style.left = lensX + 'px';
        zoomLens.style.top = lensY + 'px';
        zoomLens.style.display = 'block';

        // Correctly align background position based on cursor position
        const bgX = (x / width) * (width * zoomFactor) - lensSize / 2;
        const bgY = (y / height) * (height * zoomFactor) - lensSize / 2;

        zoomLens.style.backgroundImage = `url(${mainImage.src})`;
        zoomLens.style.backgroundSize = `${width * zoomFactor}px auto`;
        zoomLens.style.backgroundPosition = `-${bgX}px -${bgY}px`;
    });

    imageContainer.addEventListener('mouseleave', () => {
        zoomLens.style.display = 'none';
    });
  
 
});
